import { POReceivingUpdatePage } from '@/features/po-receiving/pages/POReceivingUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/receiving/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["po_receiving.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: POReceivingUpdatePage,
})
